import { computed, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgFor } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ToastService, ToastType } from '../services/toast-service.service';

@Component({
  selector: 'app-toast',
  imports: [CommonModule, NgFor, MatIconModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css',
})
export class ToastComponent {
  constructor(private toastService: ToastService) {}
  toasts = computed(() => this.toastService.toasts());

  remove(id: string) {
    this.toastService.remove(id);
  }

  getIcon(type: ToastType): string {
    switch (type) {
      case 'success':
        return 'check_circle';
      case 'error':
        return 'error';
      case 'info':
        return 'info';
      case 'warning':
        return 'warning';
      default:
        return 'info';
    }
  }
}
